import { render, staticRenderFns } from "./WsAppLayout.vue?vue&type=template&id=274e7a82&scoped=true"
import script from "./WsAppLayout.vue?vue&type=script&lang=js"
export * from "./WsAppLayout.vue?vue&type=script&lang=js"
import style0 from "./WsAppLayout.vue?vue&type=style&index=0&id=274e7a82&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "274e7a82",
  null
  
)

export default component.exports